import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';

import { Numeric } from 'components';
import { getOrdinalSuffixOf } from 'utilities';
import theme from 'theme';

const styles = {
  superscript: {
    verticalAlign: 'super',
    fontSize: theme.typography.pxToRem(20),
  },
} as const;

interface Props {
  rank: number;
}

const Rank: FC<Props> = ({ rank }) => {
  return (
    <Typography variant="h2">
      <Numeric value={rank} />
      <Box component="span" sx={styles.superscript}>
        {getOrdinalSuffixOf(rank)}
      </Box>
    </Typography>
  );
};

export default Rank;
